export default __webpack_public_path__ + "static/media/img3.1aa09731.png";